import { useState } from 'react'
import Layout from './Layout'
import api from '../services/api'
import FluxoProgresso from '../components/FluxoProgresso'

const CLS = {
  obrigatorio: { label:'Obrigatório', bg:'#FCEBEB', cor:'#791F1F' },
  recomendado: { label:'Recomendado', bg:'#FAEEDA', cor:'#633806' },
  opcional:    { label:'Opcional',    bg:'#F1EFE8', cor:'#444441' },
}

export default function ContribuintePresencial() {
  const [passo, setPasso] = useState(1)
  const [cpf, setCpf] = useState('')
  const [form, setForm] = useState({ nome:'', cpf_cnpj:'', email:'', telefone:'', endereco:'' })
  const [contribuinte, setContribuinte] = useState(null)
  const [tipos, setTipos] = useState([])
  const [tipoSel, setTipoSel] = useState(null)
  const [campos, setCampos] = useState([])
  const [docsTipo, setDocsTipo] = useState([])
  const [respostas, setRespostas] = useState({})
  const [arquivosPorDoc, setArquivosPorDoc] = useState({})
  const [arquivosExtras, setArquivosExtras] = useState([])
  const [assunto, setAssunto] = useState('')
  const [processo, setProcesso] = useState(null)
  const [erro, setErro] = useState('')
  const [load, setLoad] = useState(false)
  const [buscando, setBuscando] = useState(false)
  const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')

  function formatarCPF(v) {
    return v.replace(/\D/g,'').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d)/,'$1.$2').replace(/(\d{3})(\d{1,2})$/,'$1-$2').slice(0,14)
  }

  async function buscarCPF() {
    const cpfLimpo = cpf.replace(/\D/g,'')
    if (cpfLimpo.length < 11) { setErro('CPF inválido'); return }
    setErro(''); setBuscando(true)
    try {
      const r = await api.get(`/cidadaos/buscar-cpf/${cpfLimpo}`)
      if (r.data) {
        setContribuinte(r.data)
        setForm({ nome:r.data.nome, cpf_cnpj:r.data.cpf_cnpj, email:r.data.email||'', telefone:r.data.telefone||'', endereco:r.data.endereco||'' })
      } else {
        setContribuinte(null)
        setForm({ nome:'', cpf_cnpj:cpf, email:'', telefone:'', endereco:'' })
      }
    } catch {
      setContribuinte(null)
      setForm({ nome:'', cpf_cnpj:cpf, email:'', telefone:'', endereco:'' })
    } finally { setBuscando(false) }
    const rt = await api.get('/tipos').catch(() => ({ data:[] }))
    setTipos(rt.data)
    setPasso(2)
  }

  async function selecionarTipo(t) {
    setTipoSel(t); setCampos([]); setDocsTipo([]); setRespostas({}); setArquivosPorDoc({}); setArquivosExtras([])
    const [c, d] = await Promise.all([
      api.get(`/formulario/${t.id}`).then(r => r.data).catch(() => []),
      api.get(`/documentos-tipo/${t.id}`).then(r => r.data).catch(() => []),
    ])
    setCampos(c); setDocsTipo(d)
  }

  function renderCampo(campo) {
    const val = respostas[campo.id]||''
    const setVal = v => setRespostas(r => ({...r,[campo.id]:v}))
    const style = { width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }
    if(campo.tipo_campo==='select') {
      const opcoes = Array.isArray(campo.opcoes)?campo.opcoes:JSON.parse(campo.opcoes||'[]')
      return <select value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} style={style}>
        <option value="">Selecione...</option>
        {opcoes.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    }
    if(campo.tipo_campo==='textarea') return <textarea value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={{...style,minHeight:70,resize:'vertical'}} />
    return <input type={campo.tipo_campo||'text'} value={val} onChange={e=>setVal(e.target.value)} required={campo.obrigatorio} placeholder={campo.placeholder||''} style={style} />
  }

  async function abrirProcesso() {
    if (!form.nome) { setErro('Nome é obrigatório'); return }
    if (!tipoSel && !assunto) { setErro('Selecione o tipo ou informe o assunto'); return }
    const faltando = docsTipo.filter(d => d.classificacao==='obrigatorio' && !arquivosPorDoc[d.id])
    if (faltando.length > 0) { setErro(`Documentos obrigatórios faltando: ${faltando.map(d=>d.nome).join(', ')}`); return }
    setErro(''); setLoad(true)
    try {
      const rc = await api.post('/usuarios/contribuinte-presencial', form)
      const contrib = rc.data
      const dadosFormulario = {}
      campos.forEach(c => { if(respostas[c.id]) dadosFormulario[c.label] = respostas[c.id] })
      const rp = await api.post('/processos', {
        tipo_id: tipoSel?.id,
        assunto: tipoSel?.nome || assunto,
        req_nome: form.nome,
        req_cpf_cnpj: form.cpf_cnpj.replace(/\D/g,''),
        req_email: form.email,
        req_telefone: form.telefone,
        req_endereco: form.endereco,
        contribuinte_id: contrib.id,
        dados_formulario: dadosFormulario,
        atendimento_presencial: true
      })
      const proc = rp.data
      for (const [docTipoId, arquivo] of Object.entries(arquivosPorDoc)) {
        const fd = new FormData(); fd.append('arquivo', arquivo); fd.append('documento_tipo_id', docTipoId)
        try { await api.post(`/documentos/upload/${proc.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }) } catch {}
      }
      for (const arq of arquivosExtras) {
        const fd = new FormData(); fd.append('arquivo', arq)
        try { await api.post(`/documentos/upload/${proc.id}`, fd, { headers:{'Content-Type':'multipart/form-data'} }) } catch {}
      }
      setProcesso(proc); setPasso(3)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao abrir processo') }
    finally { setLoad(false) }
  }

  function reiniciar() {
    setPasso(1); setCpf(''); setContribuinte(null)
    setForm({ nome:'', cpf_cnpj:'', email:'', telefone:'', endereco:'' })
    setTipoSel(null); setAssunto(''); setProcesso(null); setErro('')
    setCampos([]); setDocsTipo([]); setRespostas({}); setArquivosPorDoc({}); setArquivosExtras([])
  }

  return (
    <Layout>
      <div style={{ maxWidth:680, margin:'0 auto' }}>
        <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 24px' }}>Atendimento presencial</h1>

        {/* PASSOS */}
        <div style={{ display:'flex', gap:0, marginBottom:24, background:'white', borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden' }}>
          {[{n:1,label:'Identificar cidadão'},{n:2,label:'Abrir protocolo'},{n:3,label:'Comprovante'}].map(s => (
            <div key={s.n} style={{ flex:1, padding:'10px 16px', fontSize:13, textAlign:'center', fontWeight:passo===s.n?500:400, color:passo===s.n?'#185FA5':passo>s.n?'#3B6D11':'#9ca3af', background:passo===s.n?'#f0f7ff':passo>s.n?'#f0fdf4':'white', borderRight:s.n<3?'1px solid #e5e7eb':'none' }}>
              {passo>s.n?'✓ ':''}{s.label}
            </div>
          ))}
        </div>

        {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:16 }}>{erro}</div>}

        {/* PASSO 1 */}
        {passo===1 && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:4 }}>Informe o CPF do cidadão</div>
            <div style={{ fontSize:13, color:'#9ca3af', marginBottom:20 }}>O sistema verifica se já possui cadastro automaticamente.</div>
            <div style={{ marginBottom:16 }}>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>CPF *</label>
              <input value={cpf} onChange={e=>setCpf(formatarCPF(e.target.value))} placeholder="000.000.000-00"
                onKeyDown={e=>e.key==='Enter'&&buscarCPF()}
                style={{ width:'100%', padding:'10px 12px', border:'1px solid #d1d5db', borderRadius:8, fontSize:14, boxSizing:'border-box' }} />
            </div>
            <button onClick={buscarCPF} disabled={buscando}
              style={{ width:'100%', padding:11, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>
              {buscando?'Buscando...':'Continuar'}
            </button>
          </div>
        )}

        {/* PASSO 2 */}
        {passo===2 && (
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            {/* Dados do cidadão */}
            <div style={{ background:'white', borderRadius:12, border:`1px solid ${contribuinte?'#bbf7d0':'#e5e7eb'}`, padding:20 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
                <div style={{ fontSize:14, fontWeight:500 }}>Dados do cidadão</div>
                {contribuinte
                  ? <span style={{ background:'#EAF3DE', color:'#3B6D11', fontSize:12, padding:'2px 10px', borderRadius:99 }}>✓ Cadastro encontrado</span>
                  : <span style={{ background:'#fef9c3', color:'#854d0e', fontSize:12, padding:'2px 10px', borderRadius:99 }}>Novo cadastro</span>
                }
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                {[['nome','Nome completo *'],['cpf_cnpj','CPF/CNPJ'],['email','E-mail'],['telefone','Telefone']].map(([k,l])=>(
                  <div key={k}>
                    <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>{l}</label>
                    <input value={form[k]||''} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))}
                      disabled={k==='cpf_cnpj'&&!!contribuinte}
                      style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box', background:k==='cpf_cnpj'&&contribuinte?'#f9fafb':'white' }} />
                  </div>
                ))}
                <div style={{ gridColumn:'1/-1' }}>
                  <label style={{ display:'block', fontSize:11, fontWeight:500, marginBottom:3, color:'#374151' }}>Endereço</label>
                  <input value={form.endereco||''} onChange={e=>setForm(f=>({...f,endereco:e.target.value}))}
                    style={{ width:'100%', padding:'8px 10px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
                </div>
              </div>
            </div>

            {/* Tipo */}
            <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
              <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>Tipo de solicitação</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:16 }}>
                {tipos.map(t => (
                  <div key={t.id} onClick={()=>selecionarTipo(t)} style={{ border:`2px solid ${tipoSel?.id===t.id?'#185FA5':'#e5e7eb'}`, borderRadius:10, padding:'10px 14px', cursor:'pointer', background:tipoSel?.id===t.id?'#E6F1FB':'white' }}>
                    <div style={{ fontSize:13, fontWeight:500, color:tipoSel?.id===t.id?'#185FA5':'#111' }}>{t.nome}</div>
                    {t.prazo_dias && <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>⏱ {t.prazo_dias} dias</div>}
                  </div>
                ))}
              </div>
              {!tipoSel && (
                <div>
                  <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Ou descreva o assunto</label>
                  <textarea value={assunto} onChange={e=>setAssunto(e.target.value)} placeholder="Descreva a solicitação..."
                    style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, minHeight:80, resize:'vertical', boxSizing:'border-box' }} />
                </div>
              )}
            </div>

            {/* Campos dinâmicos */}
            {tipoSel && campos.length > 0 && (
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:20 }}>
                <div style={{ fontSize:14, fontWeight:500, marginBottom:14 }}>Dados da solicitação</div>
                {campos.map(c => (
                  <div key={c.id} style={{ marginBottom:14 }}>
                    <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>
                      {c.label}{c.obrigatorio&&<span style={{ color:'#dc2626' }}> *</span>}
                    </label>
                    {renderCampo(c)}
                  </div>
                ))}
              </div>
            )}

            {/* Documentos */}
            {tipoSel && docsTipo.length > 0 && (
              <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
                <div style={{ padding:'14px 20px', borderBottom:'1px solid #f3f4f6', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div style={{ fontSize:14, fontWeight:500 }}>📎 Documentos necessários</div>
                  {docsTipo.filter(d=>d.classificacao==='obrigatorio'&&!arquivosPorDoc[d.id]).length > 0 && (
                    <span style={{ background:'#FCEBEB', color:'#791F1F', fontSize:11, padding:'2px 10px', borderRadius:99 }}>
                      {docsTipo.filter(d=>d.classificacao==='obrigatorio'&&!arquivosPorDoc[d.id]).length} obrigatório(s) faltando
                    </span>
                  )}
                </div>
                {docsTipo.map((d,i) => {
                  const cls = CLS[d.classificacao]||CLS.obrigatorio
                  const arquivo = arquivosPorDoc[d.id]
                  return (
                    <div key={d.id} style={{ padding:'14px 20px', borderBottom:i<docsTipo.length-1?'1px solid #f9fafb':'none' }}>
                      <div style={{ display:'flex', alignItems:'flex-start', gap:10 }}>
                        <div style={{ marginTop:2 }}>
                          {arquivo
                            ? <div style={{ width:20, height:20, borderRadius:'50%', background:'#EAF3DE', border:'2px solid #3B6D11', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, color:'#3B6D11' }}>✓</div>
                            : <div style={{ width:20, height:20, borderRadius:'50%', border:`2px solid ${d.classificacao==='obrigatorio'?'#fecaca':'#d1d5db'}`, background:'white' }} />
                          }
                        </div>
                        <div style={{ flex:1 }}>
                          <div style={{ display:'flex', alignItems:'center', gap:6, marginBottom:4 }}>
                            <span style={{ fontSize:13, fontWeight:500 }}>📎 {d.nome}</span>
                            <span style={{ background:cls.bg, color:cls.cor, fontSize:10, padding:'1px 7px', borderRadius:99, fontWeight:500 }}>{cls.label}</span>
                          </div>
                          {d.observacao && <div style={{ fontSize:12, color:'#6b7280', marginBottom:6 }}>💡 {d.observacao}</div>}
                          {arquivo ? (
                            <div style={{ display:'flex', alignItems:'center', gap:8, background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:'6px 10px' }}>
                              <span style={{ fontSize:12, color:'#15803d', flex:1 }}>✅ {arquivo.name}</span>
                              <button type="button" onClick={()=>setArquivosPorDoc(a=>{const n={...a};delete n[d.id];return n})} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', fontSize:12 }}>Remover</button>
                            </div>
                          ) : (
                            <button type="button" onClick={()=>{const i=document.createElement('input');i.type='file';i.accept='.pdf,.jpg,.jpeg,.png,.doc,.docx';i.onchange=e=>{if(e.target.files[0])setArquivosPorDoc(a=>({...a,[d.id]:e.target.files[0]}))};i.click()}}
                              style={{ padding:'6px 14px', border:`1.5px dashed ${d.classificacao==='obrigatorio'?'#fca5a5':'#d1d5db'}`, borderRadius:8, fontSize:12, cursor:'pointer', background:'#fafafa', color:'#374151' }}>
                              📎 Anexar
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )
                })}
                {/* Docs extras */}
                <div style={{ padding:'12px 20px', background:'#f9fafb', borderTop:'1px solid #f3f4f6' }}>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                    <div style={{ fontSize:12, color:'#6b7280' }}>Documentos adicionais (opcional)</div>
                    <button type="button" onClick={()=>{const i=document.createElement('input');i.type='file';i.multiple=true;i.accept='.pdf,.jpg,.jpeg,.png';i.onchange=e=>setArquivosExtras(a=>[...a,...Array.from(e.target.files)]);i.click()}}
                      style={{ padding:'4px 10px', border:'1px solid #d1d5db', borderRadius:6, fontSize:11, cursor:'pointer', background:'white' }}>+ Adicionar</button>
                  </div>
                  {arquivosExtras.map((a,i)=>(
                    <div key={i} style={{ display:'flex', alignItems:'center', gap:6, marginTop:6, fontSize:12 }}>
                      <span style={{ flex:1 }}>📎 {a.name}</span>
                      <button type="button" onClick={()=>setArquivosExtras(arr=>arr.filter((_,j)=>j!==i))} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer' }}>✕</button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display:'flex', gap:10 }}>
              <button onClick={()=>{setPasso(1);setErro('')}} style={{ padding:'11px 20px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>← Voltar</button>
              <button onClick={abrirProcesso} disabled={load} style={{ flex:1, padding:11, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>
                {load?'Abrindo...':'Abrir protocolo'}
              </button>
            </div>
          </div>
        )}

        {/* PASSO 3 — COMPROVANTE */}
        {passo===3 && processo && (
          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', overflow:'hidden' }}>
            <div style={{ background:'#EAF3DE', padding:'20px 24px', textAlign:'center', borderBottom:'1px solid #bbf7d0' }}>
              <div style={{ fontSize:28, marginBottom:8 }}>✅</div>
              <div style={{ fontSize:16, fontWeight:600, color:'#3B6D11' }}>Protocolo aberto com sucesso!</div>
              <div style={{ fontFamily:'monospace', fontSize:22, fontWeight:700, color:'#185FA5', marginTop:8 }}>{processo.numero}</div>
            </div>

            {/* Fluxo do processo no comprovante */}
            <div style={{ padding:'16px 20px', borderBottom:'1px solid #f3f4f6' }}>
              <FluxoProgresso processo={{ ...processo, tipo_id: tipoSel?.id, setor_atual_id: tipoSel?.setor_destino_id }} />
            </div>

            <div style={{ padding:24 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:20 }}>
                {[
                  ['Assunto', processo.assunto],
                  ['Solicitante', form.nome],
                  ['CPF', form.cpf_cnpj],
                  ['Aberto em', new Date(processo.aberto_em||Date.now()).toLocaleString('pt-BR')],
                  ['Prazo', processo.prazo_em?new Date(processo.prazo_em).toLocaleDateString('pt-BR'):'—'],
                  ['Atendente', usuario.nome]
                ].map(([l,v])=>(
                  <div key={l}><div style={{ fontSize:11, color:'#9ca3af' }}>{l}</div><div style={{ fontSize:13, fontWeight:500, marginTop:1 }}>{v}</div></div>
                ))}
              </div>
              <div style={{ display:'flex', gap:10 }}>
                <button onClick={()=>window.open(`/processos/${processo.id}/cartao`,'_blank')} style={{ flex:1, padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
                  🖨 Imprimir comprovante
                </button>
                <button onClick={reiniciar} style={{ flex:1, padding:10, border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
                  + Novo atendimento
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  )
}
